import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { EUserRole, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
const FORM_FIELD_TEMPLATE_IDENTIFIER_FIELD_NAME = "identifier";
Object.freeze(FORM_FIELD_TEMPLATE_IDENTIFIER_FIELD_NAME);
function FormFieldTemplateIdentifier({ enabled = true }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: FORM_FIELD_TEMPLATE_IDENTIFIER_FIELD_NAME,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            name: FORM_FIELD_TEMPLATE_IDENTIFIER_FIELD_NAME,
            label: getFieldNameTranslated(FORM_FIELD_TEMPLATE_IDENTIFIER_FIELD_NAME, t),
            extra: t("Each template has a unique identification. Speaking names are recommended."),
            rules: [
                {
                    required: true,
                    message: t("Please enter a unique identifier for this template.")
                },
                {
                    pattern: /^[a-z0-9-]+$/g,
                    message: t("Can contain only lowercase letters, numbers and dashes.")
                }
            ],
            required: true,
            children: /*#__PURE__*/ _jsx(Input, {
                maxLength: 255,
                placeholder: t("e.g. real-cookie-banner"),
                disabled: !enabled
            })
        })
    });
}
export { FormFieldTemplateIdentifier, FORM_FIELD_TEMPLATE_IDENTIFIER_FIELD_NAME };
